import { HeaderImage } from "@/components/Header/Circle/Styles";

export default function Circle() {
  return <HeaderImage />;
}
